export default {
  siteLogs: []
}
